import {BaseEntity} from '../../../../shared/models/ApiModels'

export const HR_PROCESS_FLOW_PATH = '/hr/process-flow'

export const NEW_STEP_NAME = 'Yeni Adım'
export const END_STEP_NAME = 'Bitiş'

/** STEP: dikdörtgen adım, END: "Bitiş" dairesi */
export type HrProcessStepType = 'STEP' | 'END'

/** Bitiş adımının sonucu: aday buraya ulaşınca süreci olumlu / olumsuz tamamlanır */
export type StepOutcome = 'POSITIVE' | 'NEGATIVE'

export const STEP_OUTCOME_LABEL: Record<StepOutcome, string> = {
  POSITIVE: 'Olumlu',
  NEGATIVE: 'Olumsuz',
}

/**
 * hr_process_step tablosu.
 * Ağaç preStepId üzerinden kurulur. nextStepId yalnızca adımın tek bir sonraki adımı varsa
 * doludur; dallanmada (çift ok, 2 alt adım) boş kalır.
 */
export interface IHrProcessStepModel extends BaseEntity {
  hrProcessId: string
  name: string
  preStepId: string | null
  nextStepId: string | null
  stepType: HrProcessStepType
  /** Yalnızca Bitiş adımında */
  outcome?: StepOutcome | null
  /** Doluysa aday bu adıma geldiğinde bu şablonla otomatik mail gönderilir */
  mailTemplateId?: string | null
  mailTemplateName?: string | null
  createdDate?: string
}

export interface IHrProcessFlowNode extends IHrProcessStepModel {
  id: string
  children: IHrProcessFlowNode[]
}

export interface IHrProcessFlowTree {
  roots: IHrProcessFlowNode[]
  nodesById: Map<string, IHrProcessFlowNode>
}

const byCreatedDate = (a: IHrProcessFlowNode, b: IHrProcessFlowNode) =>
  (a.createdDate || '').localeCompare(b.createdDate || '')

/** Düz adım listesinden (preStepId ilişkisiyle) çizilecek ağacı oluşturur */
export function buildFlowTree(steps: IHrProcessStepModel[]): IHrProcessFlowTree {
  const nodesById = new Map<string, IHrProcessFlowNode>()
  steps.forEach((step) => {
    if (step.id) nodesById.set(step.id, {...step, id: step.id, children: []})
  })

  const roots: IHrProcessFlowNode[] = []
  nodesById.forEach((node) => {
    const parent = node.preStepId ? nodesById.get(node.preStepId) : undefined
    if (parent) parent.children.push(node)
    else roots.push(node)
  })

  // Dalların sırası her yüklemede aynı kalsın
  roots.sort(byCreatedDate)
  nodesById.forEach((node) => node.children.sort(byCreatedDate))

  return {roots, nodesById}
}

/** Silme sırası: önce alt adımlar, en son adımın kendisi */
export function collectSubtreeIds(node: IHrProcessFlowNode): string[] {
  return node.children
    .reduce<string[]>((ids, child) => ids.concat(collectSubtreeIds(child)), [])
    .concat(node.id)
}

export function toStep({children, ...step}: IHrProcessFlowNode): IHrProcessStepModel {
  return step
}
